import pagination from "../static/pagination";
import registered from "../static/registered";

const moduleName = "waAutosenderModule";

const state = {
    //Api
    isFetching: false,
    isLoadMore: false,
    isFilter: false,
    isFreeReg: false,
    response: {},
    pagination: pagination(),
    tagihan: {},
    customer: { nama_customer: "Semua nomor" },
    customerId: "all",
    device: {
        nama: "Semua perangkat",
        nomor: null,
        iddevice: null,
    },

    //Register WA Autosender
    registered: registered(),
    paketWhatsapp: [],
    voucher: {},
    listPerangkat: [],
    totalPerangkat: 0,
    displayItem: [],
    endItemofPage: {},

    //Pembayaran
    listBank: [],
    qr: "",

    //Device Detail
    dataDevice: {},
    dataDeviceTiny: {},

    //Riwayat Paket
    listPaket: [],
    totalListPaket: 0,
    displayPaket: [],
    endPaket: {},
    pagePaket: pagination(),

    //Riwayat Pesan
    listPesan: [],
    detailPesan: {
        text: "",
    },
    totalListPesan: 0,
    totalFailedPesan: 0,
    displayPesan: [],
    endPesan: {},
    pagePesan: pagination(),
    listCustomer: [],

    //Outlet
    listOutlet: [],
    totalOutlet: 0,
    displayOutlet: [],
    endOutlet: {},
    pageOutlet: pagination(),
    settingOutlet: {},
    listDeviceTiny: [],
    listOutletFree: [],
    detailTemplatePesan: {},
    integrasiOulet: {
        idoutlet: null,
        iddevice: null,
    },

		historySummary: {
			averagePerDay: 0,
			recipient: null,
			totalCount: 0,
	}
};

export { state as default, moduleName };
